import React from "react";
import { Image } from "@wss/image";
import { Icon } from "@clarkinc/zest-design-system/ui";
import { FeaturedCarousel } from "../Carousel/index";
import { useHomePageData } from "../utilities";
import { usePromotionTracking, handlePromotionClick } from "../../Gtm/usePromotionTracking";
function FeaturedSectionHeader() {
  const {
    altText,
    link
  } = useHomePageData().carousel;
  return <h2 className="flex justify-left items-baseline text-sm lt:hidden" data-sentry-component="FeaturedSectionHeader" data-sentry-source-file="index.tsx">
      {altText?.trimEnd() ?? ""}
      <a className="ml-1.5 text-sm flex items-center" href={link}>
        View More{" "}
        <Icon name="ri-arrow-right-s-line" className="w-4 h-4 fill-green-500" data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
      </a>
    </h2>;
}
function FeaturedSectionImage() {
  const {
    altText,
    link,
    id,
    image
  } = useHomePageData().carousel;
  return <a href={link} className="gtm-promo hidden lt:block flex-shrink-0 lt:focus-visible:outline-[3px] lt:focus-visible:outline lt:focus-visible:outline-offset-[-3px]" data-id={id} data-name={altText} data-position="1" aria-label={altText} onClick={handlePromotionClick} data-sentry-component="FeaturedSectionImage" data-sentry-source-file="index.tsx">
      <Image className="rounded-tl rounded-bl h-full" loading="lazy" src={image} alt="" width={340} height={257} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
    </a>;
}
export const FeaturedSection = () => {
  const containerRef = React.useRef<HTMLDivElement>(null);
  const {
    carouselMembers
  } = useHomePageData().carousel;
  usePromotionTracking(containerRef);
  if (!carouselMembers?.length) return null;
  return <div id="seasonal" className="container flex flex-col lt:flex-row" data-testid="featured-carousel" data-feature-name="Seasonal Carousel" data-gtm-component="carousel" ref={containerRef} data-sentry-component="FeaturedSection" data-sentry-source-file="index.tsx">
      <FeaturedSectionHeader data-sentry-element="FeaturedSectionHeader" data-sentry-source-file="index.tsx" />
      <FeaturedSectionImage data-sentry-element="FeaturedSectionImage" data-sentry-source-file="index.tsx" />
      <FeaturedCarousel data-sentry-element="FeaturedCarousel" data-sentry-source-file="index.tsx" />
    </div>;
};